import OnboardingCarouselRouter from './onboarding-carousel-router';
export default OnboardingCarouselRouter;



// WEBPACK FOOTER //
// ./src/universal/components/onboarding/onboarding-carousel/index.js